import styled from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";
import { branch } from "@styles/branchColour";
import { focusRing } from "@components/OnboardingV2B/Shell/shell.styled";

export const DealAnchoredBannerSurface = styled.div`
  ${typographyCSS("body.md")}
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  gap: ${({ theme }) => theme.space.sm}px;
  padding: ${({ theme }) => theme.space.sm}px
    ${({ theme }) => theme.space.screen.inset}px;
  border-bottom: ${({ theme }) => theme.stroke.md}px solid
    ${({ theme }) => branch(theme, "border/warning")};
  background-color: ${({ theme }) => branch(theme, "background/warning")};
  color: ${({ theme }) => branch(theme, "text/warning")};
  text-align: center;
`;

export const DealAnchoredBannerAction = styled.button`
  ${typographyCSS("label.sm")}
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  ${focusRing}
`;
